module.exports = __webpack_public_path__ + "img/telepizza.3b4911f5.png";